<button
  id="infobulle-{{ id }}"
  class="app-habitation-v2 tooltip-btn"
  [class.tooltip-btn-style-less]="isInsideText || !showQuestionMark"
  [ngxTippy]="tooltip"
  [attr.aria-label]="ariaLabel"
  [tippyProps]="tippyProps"
  type="button"
  #tooltipButton
  appBlurOnMouseClick
>
  <img
    *ngIf="showQuestionMark"
    src="{{ 'assets/images/info.svg' | cheminAbsoluStatique }}"
    [alt]="altText"
    width="18"
    height="18"
    class="InfoBulle-pictoBtn"
  />
  <ng-content *ngIf="!showQuestionMark" select=".questionMark-replacement"></ng-content>
</button>

<div class="tooltip-content" #tooltip>
  <button id="close-btn" class="tooltip-close-btn" (click)="closeTooltip(); tooltipButton.focus()" type="button">
    <img
      src="{{ 'assets/images/icone-close.svg' | cheminAbsoluStatique }}"
      alt="{{ 'btn.fermer' | translate }}"
      width="15"
      height="15"
      class="close-icon"
    />
  </button>
  <label *ngIf="!!titre" class="dsd-t-6 dsd-c-light-graphite-t" id="titre-infobulle" [innerText]="titre"></label>
  <p *ngIf="!isCustomContent" class="text" id="texte-infobulle" [innerHTML]="texte"></p>
  <ng-content *ngIf="isCustomContent" select=".custom-content"></ng-content>
</div>
